module.exports = __webpack_public_path__ + "static/media/icon_closebox.43eac3a7.svg";